export type BookingFlowType = 'request_first' | 'instant_online' | 'bank_transfer_only';

export function shouldShowRequestForm(params: {
    productType: string;
    hasPrice: boolean;
    bookingFlow: BookingFlowType;
    showAsReservationForm?: boolean;
}): boolean {
    if (params.showAsReservationForm) return false;
    return params.productType === 'yacht' || !params.hasPrice || params.bookingFlow === 'request_first';
}

export function shouldShowReservationForm(params: {
    productType: string;
    hasPrice: boolean;
    bookingFlow: BookingFlowType;
    showAsReservationForm?: boolean;
}): boolean {
    return (
        (Boolean(params.showAsReservationForm) && params.hasPrice) ||
        (params.productType !== 'yacht' && params.hasPrice && params.bookingFlow !== 'request_first')
    );
}

export type SidebarFormTitleKind = 'request' | 'reservation' | 'reservation_private' | 'reservation_daily';

export function resolveSidebarFormTitleKind(params: {
    showRequestForm: boolean;
    showReservationForm: boolean;
    pricingPeriodType?: 'private' | 'daily' | 'group';
}): SidebarFormTitleKind {
    if (params.showRequestForm) return 'request';
    if (params.showReservationForm && params.pricingPeriodType === 'daily') return 'reservation_daily';
    if (params.showReservationForm) return 'reservation_private';
    return 'reservation';
}

export function sidebarFormTitleTranslationKey(kind: SidebarFormTitleKind): { key: string; fallback: string } {
    switch (kind) {
        case 'request':
            return { key: 'request_form.title_heading', fallback: 'Request Form' };
        case 'reservation_daily':
            return { key: 'tour_detail.sidebar_reservation_daily', fallback: 'Reservation' };
        case 'reservation_private':
            return { key: 'tour_detail.sidebar_reservation_private', fallback: 'Private reservation' };
        default:
            return { key: 'reservation.booking_title', fallback: 'Reservation' };
    }
}

/** API form detayı başlığı varsa öncelikli (CMS form title) */
export function resolveSidebarFormHeading(params: {
    titleKind: SidebarFormTitleKind;
    formTitleFromApi?: string | null;
    t: (key: string, fallback?: string) => string;
}): string {
    const apiTitle = params.formTitleFromApi?.trim();
    if (apiTitle && params.titleKind === 'request') return apiTitle;
    const { key, fallback } = sidebarFormTitleTranslationKey(params.titleKind);
    return params.t(key, fallback);
}
